import React, { FC, useState } from "react";
import { TextField } from "@foris/avocado-suite";
import styles from "./resourceSearch.module.scss";

interface ResourceSearchProps {
  onSearch: (query: string) => void;
  placeholder?: string;
}

const ResourceSearch: FC<ResourceSearchProps> = ({ onSearch, placeholder }) => {
  const [searchQuery, setSearchQuery] = useState<string>("");

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const query = e.target.value;
    setSearchQuery(query);
    onSearch(query);
  };

  return (
    <TextField
      className={styles.resourceSearch}
      icon="search"
      placeholder={placeholder}
      value={searchQuery}
      onChange={handleSearch}
    />
  );
};

export default ResourceSearch;
